<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    :width="width"
    :height="height"
    viewBox="0 0 24 24"
  >
    <path data-name="패스 4050" d="M0 0h24v24H0z" style="fill: transparent" />
    <g data-name="그룹 8645">
      <g data-name="그룹 8644">
        <path
          data-name="패스 4079"
          d="M2 0h16a2 2 0 0 1 2 2v11.835a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V2a2 2 0 0 1 2-2z"
          transform="translate(2 6)"
          style="fill: #d5d8dc"
        />
        <path
          data-name="빼기 13"
          d="M18344 14853h-2v-7h12v7h-2v-5h-8v5z"
          transform="translate(-18336 -14844)"
          style="fill: #363c43"
        />
        <path
          data-name="사각형 6432"
          transform="translate(2 11)"
          style="fill: #087ef7"
          d="M0 0h20v3H0z"
        />
      </g>
    </g>
    <path
      data-name="사각형 6436"
      transform="translate(10 10)"
      style="fill: #363c43"
      d="M0 0h4v5H0z"
    />
  </svg>
</template>

<script>
export default {
  props: {
    width: {
      type: Number,
      default: 24,
    },
    height: {
      type: Number,
      default: 24,
    },
  },
};
</script>

<style></style>
